(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prototypo"));
	else if(typeof define === 'function' && define.amd)
		define(["prototypo"], factory);
	else if(typeof exports === 'object')
		exports["PrototypoCanvas"] = factory(require("prototypo"));
	else
		root["PrototypoCanvas"] = factory(root["prototypo"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition